<template>
    <template v-for="(tile, i) in tiles" :key="tile.id">
        <MagTransition
            name="window"
            appear
            @after-leave="tileStore.remove(tile.id)"
        >
            <MagTileDecoration
                v-if="!tile.closing"
                @close="tileStore.remove(tile.id)"
                v-model:state="tiles[i]"
            >
                <template #default="{ controls }">
                    <component
                        :is="tile.client"
                        v-bind="tile.props"
                        :controls
                        @close="tileStore.remove(tile.id)"
                    />
                </template>
            </MagTileDecoration>
        </MagTransition>
    </template>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import MagTileDecoration from "@/components/tiles/MagTileDecoration.vue";
import { useTileStore } from "@/store/tile-store";

const tileStore = useTileStore();
const { tiles } = storeToRefs(tileStore);
</script>

<style scoped lang="scss">
.window-enter-active,
.window-leave-active {
    transition:
        opacity 0.2s,
        transform 0.2s;
}

.window-enter-from,
.window-leave-to {
    pointer-events: none;
    opacity: 0;
    transform: scale(0.9);
}
</style>
